import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import DevOps from "./pages/DevOps";
import FullStack from "./pages/FullStack";
import AutomationTesting from "./pages/AutomationTesting";
import JobAssistance from "./pages/JobAssistance";
import About from "./pages/About";
import Services from "./pages/Services";
import Pricing from "./pages/Pricing";
import HowItWorks from "./pages/HowItWorks";
import Register from "./pages/Register";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminRegistrations from "./pages/AdminRegistrations";
import "./App.css";

const App = () => {
  return (
    <Router>
      <div className="d-flex flex-column min-vh-100 app-shell">
        <Navbar />
        <main className="flex-fill container page-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/register" element={<Register />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/registrations" element={<AdminRegistrations />} />
            <Route path="/devops" element={<DevOps />} />
            <Route path="/fullstack" element={<FullStack />} />
            <Route path="/automation-testing" element={<AutomationTesting />} />
            <Route path="/job-assistance" element={<JobAssistance />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
